import React from 'react';
import cn from 'classnames';

import { Sidebar } from 'components/Sidebar';
import { LanguageSwitcher } from 'components/LanguageSwitcher';

import styles from './MainLayout.module.scss';

const MainLayout = ({
  className,
  children,
  toolbarComponent,
}: {
  className: any;
  children: any;
  toolbarComponent: any;
}) => (
  <div className={cn(styles.layout, className)}>
    <div className={styles.container}>
      <Sidebar />
      <div className={styles.inner}>
        <div className={styles.topBar}>
          <LanguageSwitcher />
        </div>
        <div className={styles.main}>
          {toolbarComponent}
          {children}
        </div>
      </div>
    </div>
  </div>
);

export default React.memo(MainLayout) as any;
